import { render, staticRenderFns } from "./planningConfig.vue?vue&type=template&id=37c6097a&scoped=true"
import script from "./planningConfig.vue?vue&type=script&lang=js"
export * from "./planningConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c6097a",
  null
  
)

export default component.exports